import {
  Checkbox,
  FormControl,
  MenuItem,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { SelectElement, StepValue } from "@types";
import { isArray } from "lodash";
import React from "react";

type Props = {
  element: SelectElement;
  value: string;
  disabled?: boolean;
  onChange: (id: string, value: StepValue) => void;
  style?: React.CSSProperties;
  label?: string;
};

export const Select: React.FC<Props> = ({
  disabled,
  onChange,
  value,
  element,
  style,
  label,
}) => {
  const stringOrArrayValue =
    typeof value === "string" && element.options.multiple
      ? value.trim().split(",")
      : value;

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    let value = event.target.value;

    if (element.options.multiple && isArray(value)) {
      const arrayValue = value as string[];
      value = arrayValue.filter((v) => v !== "").join(",");
    }

    onChange(element.id, { answer: value as string });
  };

  if (!element.options.options) return null;

  return (
    <FormControl className={`flex flex-col w-full`} style={style}>
      <TextField
        disabled={disabled}
        select
        SelectProps={{
          multiple: element.options.multiple,
          renderValue: (stringOrArrayValue: unknown) => {
            let value;

            if (typeof stringOrArrayValue === "string")
              value = stringOrArrayValue;
            if (Array.isArray(stringOrArrayValue))
              value = stringOrArrayValue.join(", ");
            return value;
          },
          onChange: handleChange,
        }}
        label={label}
        hiddenLabel={!label}
        id={element.id}
        value={stringOrArrayValue}
      >
        {element.options.options.map((name) => (
          <MenuItem key={name} value={name}>
            {element.options.multiple && (
              <Checkbox checked={stringOrArrayValue.indexOf(name) > -1} />
            )}

            {name}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default Select;
